import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

/**
 * Confirm-dismiss dialog opened from the X button on the Plan top bar.
 * Two CTAs: "Save & exit" (persists + nav home) and "Discard" (resets local + nav home).
 */
export default function CloseDialog({ open, onOpenChange, onSaveExit, onDiscard }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid="plan-close-dialog"
        className="bg-[#FAF7F2]"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl text-[#1A1A1A]">
            Leave the quote builder?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-[#1A1A1A]/70">
            Save your draft and come back later, or discard and start fresh next
            time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel
            data-testid="plan-close-cancel"
            className="rounded-full border-[#1A1A1A]/15 text-[#1A1A1A]"
          >
            Stay
          </AlertDialogCancel>
          <button
            type="button"
            data-testid="plan-close-discard"
            onClick={onDiscard}
            className="rounded-full border border-[#1A1A1A]/15 px-5 py-2.5 text-xs uppercase tracking-[0.22em] text-[#1A1A1A]/70 transition hover:border-[#1A1A1A] hover:text-[#1A1A1A]"
          >
            Discard
          </button>
          <AlertDialogAction
            data-testid="plan-close-save-exit"
            onClick={onSaveExit}
            className="rounded-full bg-[#C8A24B] px-5 py-2.5 text-xs uppercase tracking-[0.22em] text-[#1A1A1A] hover:bg-[#dbb359]"
          >
            Save &amp; exit
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
